import { React, useState } from 'react';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { FaPhone } from 'react-icons/fa6';
import { IoIosMail } from "react-icons/io";

const Container = styled.div`
  background-color: #fdfdfd;
  margin: auto;
  padding: 1em;
  margin-bottom: 100px;
  min-height: 710px;
  width:80vw;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 768px) {
    margin-top: 50px;
    padding: 0.5em;
    min-height: auto;
  }
`;

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 2em;
  padding: 2em;
  width: 100%;
  max-width: 1200px;

  @media (max-width: 968px) {
    gap: 1em;
    padding: 1em;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 2em;
  }
`;

const FormWrapper = styled.div`
  padding: 2em;
  border-radius: 30px;

  @media (max-width: 768px) {
    padding: 1em;
  }
`;

const FormTitle = styled.h4`
  margin-bottom: 35px;
  font-size: 22px;
  font-family: Poppins;
  font-weight: 600;
  color: #212d31;

  @media (max-width: 768px) {
    font-size: 20px;
    margin-bottom: 25px;
  }
`;

const Label = styled.label`
  display: block;
  margin-top: 50px;
  margin-bottom: 10px;
  color: #212d31;
  font-family: Poppins;

  @media (max-width: 768px) {
    margin-top: 30px;
    font-size: 14px;
  }
`;

const Input = styled.input`
  width: 100%;
  height: 50px;
  background-color: #eaf4ff;
  border: 1px solid #bdbdbd;
  border-radius: 15px;
  padding: 0.5em;

  @media (max-width: 768px) {
    height: 40px;
  }
`;

const Textarea = styled.textarea`
  width: 100%;
  background-color: #eaf4ff;
  border: 1px solid #bdbdbd;
  border-radius: 15px;
  color: #212d31;
  padding: 15px;
  font-family: Poppins;
  font-size: 16px;
  min-height: 100px;

  @media (max-width: 768px) {
    font-size: 14px;
    min-height: 80px;
  }
`;

const ContactWrapper = styled.div`
  font-family: 'Raleway', Arial, sans-serif;
  font-size: 18px;
  margin: auto 20px;
  color: #212d31;

  @media (max-width: 968px) {
    font-size: 16px;
    margin: auto 10px;
  }

  @media (max-width: 768px) {
    font-size: 14px;
    margin: auto 5px;
  }
`;

const HighlightInfo = styled.div`
  font-weight: 700;
  font-size: 22px;
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  gap: 7px;
  line-height: 1.5;

  @media (max-width: 968px) {
    font-size: 18px;
  }

  @media (max-width: 768px) {
    font-size: 16px;
    margin-top: 20px;
  }
`;

const ContactList = styled.ul`
  list-style: none;
  padding: 0;

  @media (max-width: 768px) {
    li {
      font-size: 14px;
    }
  }
`;

const StyledWrapper = styled.div`
  .animated-button {
    position: relative;
    display: flex;
    align-items: center;
    margin-top: 50px;
    gap: 4px;
    padding: 16px 36px;
    border: 4px solid;
    border-color: transparent;
    font-size: 16px;
    background-color: inherit;
    border-radius: 100px;
    font-weight: 600;
    color: #212d31;
    box-shadow: 0 0 0 2px #212d31;
    cursor: pointer;
    overflow: hidden;
    transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1);

    @media (max-width: 768px) {
      margin-top: 30px;
      padding: 12px 28px;
      font-size: 14px;
    }
  }

  .animated-button svg {
    position: absolute;
    width: 24px;
    fill: #212d31;
    z-index: 9;
    transition: all 0.8s cubic-bezier(0.23, 1, 0.32, 1);

    @media (max-width: 768px) {
      width: 20px;
    }
  }

  /* Rest of the button styles remain the same */
  .animated-button .arr-1 {
    right: 16px;
  }

  .animated-button .arr-2 {
    left: -25%;
  }

  .animated-button .circle {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 20px;
    height: 20px;
    background-color: #212d31;
    border-radius: 50%;
    opacity: 0;
    transition: all 0.8s cubic-bezier(0.23, 1, 0.32, 1);
  }

  .animated-button .text {
    position: relative;
    z-index: 1;
    transform: translateX(-12px);
    transition: all 0.8s cubic-bezier(0.23, 1, 0.32, 1);
  }

  .animated-button:hover {
    box-shadow: 0 0 0 12px transparent;
    color: #ffffff;
    border-radius: 12px;
  }

  .animated-button:hover .arr-1 {
    right: -25%;
  }

  .animated-button:hover .arr-2 {
    left: 16px;
  }

  .animated-button:hover .text {
    transform: translateX(12px);
  }

  .animated-button:hover svg {
    fill: #ffffff;
  }

  .animated-button:active {
    scale: 0.95;
    box-shadow: 0 0 0 4px greenyellow;
  }

  .animated-button:hover .circle {
    width: 220px;
    height: 220px;
    opacity: 1;
  }
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  svg {
    @media (max-width: 768px) {
      width: 20px !important;
      height: 20px !important;
    }
  }
`;

const Contact = () => {
  const [mail, setMail] = useState('');
  const [message, setMessage] = useState('');

  const checkValidations = () => {
    toast.success('En kısa zamanda size geriş dönüş yapacağız.');
    setMail('');
    setMessage('');
  };

  return (
    <Container id="aboutSection">
      <Wrapper>
        <FormWrapper>
          <FormTitle>İLETİŞİM KUTUSU</FormTitle>
          <form onSubmit={(e) => e.preventDefault()}>
            <p>
              <Label htmlFor="email">Mail Adresin</Label>
              <Input
                type="email"
                id="email"
                value={mail}
                onChange={(e) => setMail(e.target.value)}
                required
              />
            </p>
            <p>
              <Label htmlFor="message">Mesajın</Label>
              <Textarea
                id="message"
                minLength="20"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                required
              />
            </p>
            <p>
              <StyledWrapper>
                <button className="animated-button" type="button" onClick={checkValidations}>
                  <svg viewBox="0 0 24 24" className="arr-2" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z" />
                  </svg>
                  <span className="text">Gönder</span>
                  <span className="circle" />
                  <svg viewBox="0 0 24 24" className="arr-1" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z" />
                  </svg>
                </button>
              </StyledWrapper>
            </p>
          </form>
        </FormWrapper>

        <ContactWrapper>
          <ContactList>
            <li>Projeleriniz için en uygun çözümlerle yanınızdayız. Detaylar için bizimle iletişime geçin!</li>
            <HighlightInfo>
              <IconWrapper>
                <IoIosMail style={{width:"30px", height:"30px", color:"#212d31"}} />
                aokan2617@gmail.com
              </IconWrapper>
              <IconWrapper>
                <FaPhone style={{width:"25px", height:"25px", color:"#212d31"}} />
                0545 936 74 80
              </IconWrapper>
            </HighlightInfo>
          </ContactList>
        </ContactWrapper>
      </Wrapper>
    </Container>
  );
};

export default Contact;